import React, { FC } from 'react'
import { NotesProps as Props } from './types'
import { Button, ConfirmModal, EditableMultiSelect, Input, ROLES, Switch, Title, USER_STATUS } from 'prace-common-components'
import { $GridContainer, $IconButton, $Message } from './styles'
import Grid from '@material-ui/core/Grid'
import { Box, FormControl, FormHelperText, Paper, Popper, Typography } from '@material-ui/core'
import { $ActivateIcon, $EnvelopeIcon } from './icons'

export const Notes: FC<Props> = ({ user, readOnly, onChangeUserRemarks, onChangeUserTags, onChangeStatus }) => {
  const { status, role } = user
  const [open, setOpen] = React.useState(false)
  const anchorEl = React.useRef<HTMLButtonElement>(null)
  const [popperOpen, setPopperOpen] = React.useState(false)

  const confirmBlackList = () => {
    onChangeStatus('status', status !== USER_STATUS.Active ? USER_STATUS.Active : USER_STATUS.Blocked)
    setOpen(false)
  }

  const isInvitePending = status === USER_STATUS.Locked || status === USER_STATUS.Inactive

  return <>
    <Title subTitle>Notes</Title>
    <$GridContainer container>
      <Grid item xs={12}>
        <Input
          debounce
          hideLabel
          title=''
          name='userRemarks'
          value={user.userRemarks}
          onChange={(_, value) => onChangeUserRemarks('userRemarks', value as string)}
          multiline
          minRows={8}
          type='text'
          hideItalic
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <EditableMultiSelect
          name='tags'
          value={user.tags ? user.tags.filter((tag) => !!tag) : []}
          title='User Tags'
          placeholder='Separate tags by a comma: tag1, tag2, tag3...'
          hideItalic
          disabled={readOnly}
          onChange={(_, value) => onChangeUserTags('tags', value as string[])}
        />
      </Grid>
      <Grid item xs={12}>
        {/* //TODO: Make sure this is the same as disable user? */}
        <FormControl>
          {!isInvitePending && ![ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(role) && (
            <Switch
              name='blacklist'
              title={'Blocked User'}
              value={status === USER_STATUS.Blocked}
              disabled={readOnly}
              onChange={() => setOpen(true)}
            />
          )}

          {isInvitePending && (
            <Popper
              open={popperOpen}
              anchorEl={anchorEl?.current}
              placement='top-start'
              disablePortal={false}
              modifiers={{
                flip: {
                  enabled: true,
                },
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'scrollParent',
                },
                arrow: {
                  enabled: true,
                  element: anchorEl?.current,
                },
              }}
              title={'Activate User'}
              style={{ zIndex: 9999 }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 2 }} component={Paper}>
                <Grid item>
                  <Typography variant={'h6'}>
                    {'Activate User'}
                  </Typography>
                  <$Message variant={'body1'}>
                    {'Are you sure you want to manually activate this user?'}
                  </$Message>
                </Grid>
                <Grid container justifyContent='space-between'>
                  <Button variant={'text'} onClick={() => setPopperOpen(false)}>
                    {'Cancel'}
                  </Button>
                  <$IconButton
                    aria-label='activate user'
                    onClick={() => {
                      onChangeStatus('status', USER_STATUS.Active)
                      setPopperOpen(false)
                    }}
                  >
                    <$ActivateIcon/>
                  </$IconButton>
                </Grid>
              </Box>
            </Popper>
          )}

          {isInvitePending && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {!readOnly && <Box sx={{ mr: 1 }}>
                <$IconButton
                  ref={anchorEl}
                  aria-label='activate user'
                  onClick={() => setPopperOpen(true)}
                >
                  <$EnvelopeIcon/>
                </$IconButton>
              </Box>}
              <FormHelperText>
                {'Invitation pending.'}
              </FormHelperText>
            </Box>
          )}

        </FormControl>
      </Grid>
    </$GridContainer>
    {open &&
      <ConfirmModal
        open
        title={status !== USER_STATUS.Active ? 'Activate user' : 'Block User'}
        onConfirm={confirmBlackList}
        onClose={() => setOpen(false)}
      />
    }
  </>
}
